import { Flex, Text } from '@chakra-ui/react';
import { GoogleNfcWavesIcon } from '../../../../../theme/icons/googlePreviewIcons';
import { HIGHLIGHT_COLOR } from './GoogleExpressivePassPreview';

interface GoogleNfcBadgeProps {
  contrastColor: string;
  isHighlighted?: boolean;
}

export const GoogleNfcBadge = ({ contrastColor, isHighlighted }: GoogleNfcBadgeProps) => (
  <Flex
    w="full"
    justifyContent="center"
    mt={4}
    mb={1}
    data-highlighted={isHighlighted || undefined}
  >
    <Flex
      bg={contrastColor === '#000000' ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.15)'}
      borderRadius="full"
      px="14px"
      py="10px"
      alignItems="center"
      gap="6px"
      boxShadow={isHighlighted ? `0 0 0 2px ${HIGHLIGHT_COLOR}` : undefined}
    >
      <GoogleNfcWavesIcon w="16px" h="16px" color={contrastColor} />
      <Text
        fontSize="12px"
        fontWeight="700"
        textStyle="headingFamilyRegularGooglePay"
        color={contrastColor}
      >
        Hold to reader
      </Text>
    </Flex>
  </Flex>
);
